import type { IconDefinition } from '../index.tsx';

export const iconCode: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconCode',
  icon: [
    16,
    16,
    [],
    '',
    'M8.01005 0.858398L6.01005 14.8584L7.98995 15.1412L9.98995 1.14124L8.01005 0.858398Z M12.5 11.4998L11.0858 10.0856L13.1716 7.99982L11.0858 5.91403L12.5 4.49982L16 7.99982L12.5 11.4998Z M2.82843 7.99982L4.91421 10.0856L3.5 11.4998L0 7.99982L3.5 4.49982L4.91421 5.91403L2.82843 7.99982Z',
  ],
};
